/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { createContext, useContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var TrainingSpeedQuizContext = /*#__PURE__*/createContext({
  isSpeedQuizRunning: function isSpeedQuizRunning() {
    return false;
  },
  startSpeedQuiz: function startSpeedQuiz() {},
  stopSpeedQuiz: function stopSpeedQuiz() {}
});

var TrainingSpeedQuizProvider = function TrainingSpeedQuizProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(false),
      _isSpeedQuizRunning = _useState[0],
      setIsSpeedQuizRunning = _useState[1];

  var startSpeedQuiz = function startSpeedQuiz() {
    setIsSpeedQuizRunning(true);
  };

  var stopSpeedQuiz = function stopSpeedQuiz() {
    setIsSpeedQuizRunning(false);
  };

  return /*#__PURE__*/_jsx(TrainingSpeedQuizContext.Provider, {
    value: {
      isSpeedQuizRunning: function isSpeedQuizRunning() {
        return _isSpeedQuizRunning;
      },
      startSpeedQuiz: startSpeedQuiz,
      stopSpeedQuiz: stopSpeedQuiz
    },
    children: children
  });
};

export var useTrainingSpeedQuiz = function useTrainingSpeedQuiz() {
  return useContext(TrainingSpeedQuizContext);
};
export default TrainingSpeedQuizProvider;